import { isCmpUifFilterSelectionBarEnabled } from '../../../../feature-flags';
import { SET_FILTER_SELECTION_BAR_VISIBILITY } from '../../../actions/filter';
import type { Action } from '../../../types';
import type { FilterSelectionBarState } from './types';

const defaultState = { isVisible: false } as const;

const FilterSelectionBarReducer = (
	state: FilterSelectionBarState = defaultState,
	action: Action,
): FilterSelectionBarState => {
	if (!isCmpUifFilterSelectionBarEnabled()) {
		return defaultState;
	}

	if (action.type === SET_FILTER_SELECTION_BAR_VISIBILITY) {
		const { isVisible } = action.payload;

		return {
			...state,
			isVisible,
		};
	}

	return state;
};

export default FilterSelectionBarReducer;
